import { TSetFunc } from '@libs/types';
import { ConditionalRender } from '@libs/core';
import React, { useCallback, useRef, useState } from 'react';
import Webcam from 'react-webcam';
import { ButtonPillView } from '../../Buttons/ButtonPillView';
import styled from './profileImage.module.css';

type TWebcamCaptureProps = {
    handleClick: (value: string) => void;
    setModal: TSetFunc;
};

const WebcamCapture = ({ handleClick, setModal }: TWebcamCaptureProps) => {
    const webcamRef = useRef<Webcam>(null);
    const [imgSrc, setImgSrc] = useState<string>('');
    const [isShowCamera, setShowCamera] = useState(true);

    const onCaptureClick = useCallback(async () => {
        const value = webcamRef?.current?.getScreenshot();
        if (value) {
            setImgSrc(value);
            setShowCamera(false);
        }
    }, [webcamRef, setImgSrc]);

    return (
        <>
            <ConditionalRender condition={isShowCamera}>
                <div className={styled.webcamContainer}>
                    <Webcam onUserMediaError={() => setModal(null)} audio={false} ref={webcamRef} screenshotFormat="image/jpeg" width={400} height={500} />
                </div>
                <div className={styled.buttonContainer}>
                    <ButtonPillView label="Capture photo" hierarchy="secondary" onClick={onCaptureClick} position="inline" />
                </div>
            </ConditionalRender>
            <ConditionalRender condition={!isShowCamera && Boolean(imgSrc)}>
                <img className={styled.image} src={imgSrc} width="400" height="500" alt="Capture" />
                <div className={styled.buttonContainer}>
                    <ButtonPillView label="Take a photo" hierarchy="secondary" onClick={() => setShowCamera(true)} position="inline" />
                    <ButtonPillView label="Upload photo" hierarchy="secondary" onClick={() => handleClick(imgSrc)} position="inline" />
                </div>
            </ConditionalRender>
        </>
    );
};
export { WebcamCapture };
